export const HOME = {
  emergentLink: "home-emergent-link",
};

export const SOLAR = {
  pageRoot: "solar-page-root",
  latInput: "solar-lat-input",
  lonInput: "solar-lon-input",
  placeInput: "solar-place-input",
  placeSearchBtn: "solar-place-search-btn",
  placeResult: "solar-place-result",
  placeLabel: "solar-place-label",
  approxNote: "solar-approx-note",
  shareBtn: "solar-share-btn",
  shareStatus: "solar-share-status",
  forgetBtn: "solar-forget-btn",
  sharedNote: "solar-shared-note",
  leaveSharedBtn: "solar-leave-shared-btn",
  applyCoordsBtn: "solar-apply-coords-btn",
  useLocationBtn: "solar-use-location-btn",
  toggleManualBtn: "solar-toggle-manual-btn",
  togglePlaceBtn: "solar-toggle-place-btn",
  toggleMapBtn: "solar-toggle-map-btn",
  trueSolarTime: "solar-true-time",
  clockTime: "solar-clock-time",
  clockZone: "solar-clock-zone",
  offset: "solar-offset",
  eot: "solar-eot",
  eotObliquity: "solar-eot-obliquity",
  eotEccentricity: "solar-eot-eccentricity",
  lonCorr: "solar-lon-corr",
  solarNoon: "solar-solar-noon",
  sunrise: "solar-sunrise",
  sunriseSolar: "solar-sunrise-solar",
  sunset: "solar-sunset",
  sunsetSolar: "solar-sunset-solar",
  dayLength: "solar-day-length",
  errorMsg: "solar-error-msg",
};
